// Token cache duration for upload operations
// Server token validity: 15 minutes
// Cache refresh interval: 360 seconds (conservative to avoid edge cases)
export const TOKEN_CACHE_DURATION = 360 * 1000

// Default concurrency for parallel chunk uploads
export const DEFAULT_UPLOAD_CONCURRENCY = 6
